<header class="app-header">
  <div class="brand">
    <span class="brand-mark">P</span>
    <span class="brand-name">DH</span>
  </div>

  <div class="header-actions">
    <button type="button" class="icon-btn" (click)="toggleTheme()" [title]="(theme$ | async) === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'">
      <svg *ngIf="(theme$ | async) === 'dark'" viewBox="0 0 24 24" fill="none"><path d="M12 3v2m0 14v2m9-9h-2M5 12H3m14.4-6.4-1.4 1.4M7 17.4l-1.4 1.4m12.8 0-1.4-1.4M7 6.6 5.6 5.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.7"/></svg>
      <svg *ngIf="(theme$ | async) !== 'dark'" viewBox="0 0 24 24" fill="none"><path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>
    </button>

    <div class="user-menu" *ngIf="currentUser$ | async as user">
      <button type="button" class="user-trigger" (click)="toggleMenu()">
        <span class="avatar">{{ initials(user) }}</span>
        <span class="user-text">
          <span class="user-name">{{ user.fullName }} ({{ user.ntUserId }})</span>
          <span class="user-role">{{ user.roles[0] || 'User' }}</span>
        </span>
        <svg class="chevron" viewBox="0 0 24 24" fill="none"><path d="m6 9 6 6 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>

      <div class="user-dropdown" *ngIf="menuOpen">
        <button type="button" class="dropdown-item" (click)="logout()">Log out</button>
      </div>
    </div>
  </div>
</header>
